/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const FileXLS = (props: { className?: string }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22.004"
    viewBox="0 0 22 22.004"
  >
    <g id="document--excel" transform="translate(0.367)">
      <path
        id="Tracé_6209"
        d="M15.557,10.134V7.423a.616.616,0,0,0-.2-.474L10.609,2.2a.616.616,0,0,0-.475-.2H3.356A1.36,1.36,0,0,0,2,3.356V19.624A1.356,1.356,0,0,0,3.356,20.98H14.2V19.624H3.356V3.356H8.779V7.423a1.36,1.36,0,0,0,1.356,1.356H14.2v1.356ZM10.134,7.423v-3.8l3.8,3.8Z"
        transform="translate(-0.644 -0.644)"
        fill="#2e9890"
      />
      <rect
        id="_Transparent_Rectangle_"
        width="22"
        height="22"
        transform="translate(-0.367)"
        fill="none"
      />
      <text
        id="XLS"
        transform="translate(4.209 17.336)"
        fill="#2e9890"
        fontSize="8"
        fontWeight="800"
      >
        <tspan x="0" y="0">
          XLS
        </tspan>
      </text>
      <path
        id="Tracé_6445"
        d="M0,40"
        transform="translate(3.809 -17.996)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export { FileXLS };
